/* Sui Story — first-visit newsletter popup.
   Shows once per SESSION (sessionStorage), on whatever page the visitor opens, after a short
   delay or first scroll. Dialog markup lives in snippets/newsletter-popup.liquid (#NewsletterPopup).
   Captures email + phone (carried into the customer's tags as ph-<digits>) + consent.
   Manual trigger: any [data-newsletter-open]. Dismiss: [data-newsletter-close] / backdrop / Esc. */
(function () {
  var KEY = 'suistory:newsletter:v1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var dlg = document.getElementById('NewsletterPopup');
    if (!dlg) return;

    var delay = parseInt(dlg.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 4500;

    // Per-session: sessionStorage clears when the browsing session ends, so the popup
    // returns on the next visit (but only once per session, on any landing page).
    function seen() { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } }
    function remember(v) { try { sessionStorage.setItem(KEY, v); } catch (e) {} }

    function open() {
      if (dlg.open) return;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      dlg.classList.add('is-open');
    }
    function close(flag) {
      remember(flag || 'dismissed');
      dlg.classList.remove('is-open');
      var done = function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); };
      if (reduce) done(); else setTimeout(done, 240);
    }

    // dismiss interactions
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-newsletter-close]')) close('dismissed');
    });
    dlg.addEventListener('cancel', function () { remember('dismissed'); }); // Esc

    // manual open (footer link etc.)
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-newsletter-open]')) { e.preventDefault(); open(); }
    });

    // Wire the form: require consent, carry the phone into the customer's tags, remember subscribed
    var form = dlg.querySelector('form');
    if (form) {
      var consentBox = form.querySelector('[data-np-consent]');
      var consentErr = form.querySelector('[data-np-consent-error]');
      if (consentBox && consentErr) {
        consentBox.addEventListener('invalid', function () { consentErr.hidden = false; });
        consentBox.addEventListener('change', function () { if (consentBox.checked) consentErr.hidden = true; });
      }
      form.addEventListener('submit', function () {
        if (consentBox && !consentBox.checked) { if (consentErr) consentErr.hidden = false; return; }
        var phone = form.querySelector('[data-np-phone]');
        var tags = form.querySelector('[data-np-tags]');
        if (tags) {
          var digits = phone ? (phone.value || '').replace(/[^0-9]/g, '') : '';
          tags.value = 'newsletter, popup' + (digits ? ', ph-' + digits : '');
        }
        remember('subscribed');
      });
    }

    // If the signup just succeeded, reveal the dialog with the code — even for a "seen" visitor
    var justPosted = /[?&]customer_posted=true/.test(window.location.search) || !!dlg.querySelector('[data-np-copy]');
    if (justPosted) {
      remember('subscribed');
      var copyBtn = dlg.querySelector('[data-np-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = copyBtn.getAttribute('data-code') || copyBtn.textContent.trim();
          if (navigator.clipboard) { try { navigator.clipboard.writeText(code); } catch (e) {} }
          var orig = copyBtn.textContent;
          copyBtn.textContent = 'Copied ✓';
          setTimeout(function () { copyBtn.textContent = orig; }, 1500);
        });
        open();
      }
      return;
    }

    // auto-show — skip in Theme Editor and for returning/converted visitors
    if (window.Shopify && Shopify.designMode) return;
    if (seen()) return;

    var shown = false;
    var trigger = function () { if (shown) return; shown = true; open(); };
    setTimeout(trigger, delay);
    window.addEventListener('scroll', function onScroll() {
      if ((window.scrollY || 0) > 600) { trigger(); window.removeEventListener('scroll', onScroll); }
    }, { passive: true });
  });
})();
